export default "__VITE_PUBLIC_ASSET__0cfc2393__"